import { defineSlotRecipe } from '@chakra-ui/react'

export const cardSlotRecipe = defineSlotRecipe({
  className: 'chakra-card',
  slots: ['root', 'header', 'body', 'footer', 'title', 'description'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minWidth: '0',
      wordWrap: 'break-word',
      borderRadius: 'l3',
      color: 'fg',
      textAlign: 'start',
    },
    title: {
      fontWeight: 'semibold',
    },
    description: {
      color: 'fg.muted',
      fontSize: 'sm',
    },
    header: {
      paddingInline: 'var(--card-padding)',
      paddingTop: 'var(--card-padding)',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5',
    },
    body: {
      padding: 'var(--card-padding)',
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      gap: '2',
      paddingInline: 'var(--card-padding)',
      paddingBottom: 'var(--card-padding)',
    },
  },
  variants: {
    size: {
      sm: {
        root: {
          '--card-padding': 'spacing.4',
        },
        title: {
          textStyle: 'md',
        },
      },
      md: {
        root: {
          '--card-padding': 'spacing.6',
        },
        title: {
          textStyle: 'lg',
        },
      },
      lg: {
        root: {
          '--card-padding': 'spacing.7',
        },
        title: {
          textStyle: 'xl',
        },
      },
    },
    variant: {
      elevated: {
        root: {
          bg: 'colorPalette.card',
          boxShadow: 'sm',
        },
      },
      outline: {
        root: {
          bg: 'transparent',
          borderWidth: '1px',
          borderColor: 'colorPalette.border',
        },
      },
      subtle: {
        root: {
          bg: 'colorPalette.container',
          boxShadow: 'sm',
        },
      },
      muted: {
        root: {
          bg: 'colorPalette.card/50',
          boxShadow: 'sm',
        },
      },
      // Clickable / linked cards: tinted rest state, stronger border + lift on hover.
      interactive: {
        root: {
          bg: 'colorPalette.card/20',
          borderWidth: '1px',
          borderColor: 'colorPalette.border/50',
          cursor: 'button',
          transitionDuration: 'moderate',
          transitionProperty: 'common',
          _hover: {
            bg: 'colorPalette.card/40',
            borderColor: 'colorPalette.border',
            transform: 'scale(1.01)',
            boxShadow: 'sm',
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: 'outline',
    size: 'md',
  },
})
